import * as React from 'react';
import Icon from '../../Icon';
import { components as CoreComponent } from 'react-select';

var MultiValueRemoveWrapper = function MultiValueRemoveWrapper(props) {
  return React.createElement(CoreComponent.MultiValueRemove, props, React.createElement(Icon, {
    type: "times",
    variant: "light"
  }));
};

export default MultiValueRemoveWrapper;